import { AppError, ErrorType } from '~/models/app-error';
import type { QueryErrorResponse } from '~/repositories/query-repository';

export function handleError(response: Response): Response {
  if (response.status === 409) {
    throw new AppError(
      ErrorType.API_REQUEST_409,
      '',
      response.status,
      response
    );
  }
  if (response.status >= 400 && response.status < 500) {
    throw new AppError(
      ErrorType.API_REQUEST_404,
      '',
      response.status,
      response
    );
  }
  if (response.status >= 500 && response.status < 600) {
    throw new AppError(
      ErrorType.API_REQUEST_500,
      '',
      response.status,
      response
    );
  }
  return response;
}

export function convertIErrorResponseToAppError(
  response: QueryErrorResponse
): AppError {
  let status = response.status;
  if (status === 409) {
    return new AppError(
      ErrorType.API_REQUEST_409,
      response.message ?? '',
      status,
      undefined
    );
  }
  if (status && status >= 400 && status < 500) {
    return new AppError(
      ErrorType.API_REQUEST_404,
      response.message ?? '',
      status,
      undefined
    );
  }
  if (status && status >= 500 && status < 600) {
    return new AppError(
      ErrorType.API_REQUEST_500,
      response.message ?? '',
      status,
      undefined
    );
  }

  return new AppError(
    ErrorType.UNKNOWN_ERROR,
    response.message ?? '',
    status ?? 0,
    undefined
  );
}
